import * as React from "react";
import Svg, { Path } from "react-native-svg";

const ToBeCompleteStepIndicator = () => (
  <Svg width={24} height={24} fill="#fff" xmlns="http://www.w3.org/2000/svg">
    <Path
      d="M3 12c0-4.968 4.032-9 9-9s9 4.032 9 9-4.032 9-9 9-9-4.032-9-9Z"
      fill="#fff"
      stroke="#AEAEAE"
      strokeWidth={2}
    />
    <Path
      d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5Z"
      fill="#AEAEAE"
    />
  </Svg>
);

export default ToBeCompleteStepIndicator;
